/* eslint-disable import/order */
import { yourWorkRedirectPageEntryPoint } from '@jira/spa-apps__your-work-redirect/src/yourWorkRedirectPageEntryPoint.entrypoint.tsx';
import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { jiraHomeResourceWithCache } from '@jira/router-resources__jira-home-page-data/src/jiraHomeResourceWithCache.tsx';
import { CONSOLIDATION_STATE_RESOURCE_TYPE } from '@jira/router-resources__eoc-tenant-info/src/consolidationStateResourceType.constants.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import type { TenantInfo } from '@jira/router-resources__eoc-tenant-info/src/TenantInfo.types.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { checkShouldUseJSM } from '@jira/eoc__tenant-info/src/controllers/utils.tsx';
import { homepageLayout } from '@jira/platform__layouts-homepage-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { oldJiraHomeRoute } from '@jira/router-routes__jira-home-routes/src/oldJiraHomeRoute.tsx';
import { postOfficeJiraYourWorkResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { YourWorkSkeleton } from '@jira/platform__skeletons/src/ui/your-work/YourWorkItemListSkeleton.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { widgetResources as alertsWidgetResources } from '@atlassian/eoc-alerts-widget/resources';
import { widgetResources as onCallWidgetResources } from '@atlassian/eoc-who-is-on-call/resources';
import type {
	Route,
	RouteResourceResponse,
	RouteResources,
} from '@atlassian/react-resource-router';

const conditionalPostOfficeJiraYourWorkResource = resourceWithCondition(
	() => fg('post_office_ssr_jira_your_work_enabled'),
	postOfficeJiraYourWorkResource,
);

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

const checkConsolidationOnRouteDependency = async (dependencies: ResourceDependencies) => {
	const data = await dependencies[CONSOLIDATION_STATE_RESOURCE_TYPE].promise;
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return checkShouldUseJSM(data as TenantInfo | null);
};

const oldJiraHomeEntryPoint = createPageEntryPoint({
	main: yourWorkRedirectPageEntryPoint,
});

export const oldJiraHomeRouteEntry: Route = createEntry(oldJiraHomeRoute, () => ({
	group: 'home',
	ufoName: 'jira-home',
	skeleton: YourWorkSkeleton,
	layout: homepageLayout,

	entryPoint: () => oldJiraHomeEntryPoint,

	navigation: {
		menuId: MenuIdHome,
	},

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		jiraHomeResourceWithCache,
		conditionalPostOfficeJiraYourWorkResource,
		getConsolidationStateResource(),
		...onCallWidgetResources.map((resourceCreator) =>
			resourceCreator(checkConsolidationOnRouteDependency, [CONSOLIDATION_STATE_RESOURCE_TYPE]),
		),
		...alertsWidgetResources.map((resourceCreator) =>
			resourceCreator(checkConsolidationOnRouteDependency, [CONSOLIDATION_STATE_RESOURCE_TYPE]),
		),
	] as RouteResources,

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
